export default Object.freeze({
  ENTITY_NAME: 'project',
  NAME: 'name',
  CODE: 'code',

  SUB_ACCOUNT_CODE: 'subaccount_code',
  MASTER_ACCOUNT_CODE: 'master_account_code'
})
